export const LTL_MAX_PALLETS = 6;

export type PalletShippingMode = "FTL" | "LTL";

export function shippingModeForPallets(palletCount: number): PalletShippingMode {
  return palletCount <= LTL_MAX_PALLETS ? "LTL" : "FTL";
}
